import { Button, Modal } from "components"
import moment from "moment"
import { useRef } from "react"
import ReactToPrint from "react-to-print"
import { convertNumber } from "utils"
import { FormReconcileType } from "../types"

type PrintReconcileProps = {
  isLoading?: boolean
  bank?: string
  date?: string
  company?: string
  data: FormReconcileType['data']
  toggle: () => void
}

export const PrintReconcile = ({ data, toggle, isLoading, bank, date, company }: PrintReconcileProps) => {
  const ref = useRef<HTMLDivElement>(null)

  return (
    <Modal isOpen title="Print Preview" closeModal={toggle}>
      <Modal.Body>
        <section ref={ref} >
          <section className="flex flex-col gap-1.5 mx-4 mt-6">
            <div className="mt-8 font-bold text-2xl uppercase">{bank} Reconciliation Summary</div>
            <div className="font-semibold text-lg uppercase">{company}</div>
            <div className="font-semibold text-lg">As at {moment(date).locale("en-US").format("DD MMMM YYYY")}</div>
            <div className="font-semibold text-lg capitalize">{bank}</div>

            <table className="table mt-2">
              <thead className="text-black">
                <tr className="uppercase">
                  <th className="text-start">Date</th>
                  <th className="text-start">Description</th>
                  <th className="text-start">Reference</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="ps-0 pt-4 pb-1 border-b-[1.2px] border-b-black font-bold" colSpan={4}>Totals Summary</td>
                </tr>
                {data.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{moment(item.transaction_date).format("DD MMM YYYY")}</td>
                      <td>{item.memo}</td>
                      <td>{item.reference_no}</td>
                      <td className="text-right">{convertNumber(item.amount).intoCurrency}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </section>
        </section>
      </Modal.Body>

      <Modal.Footer>
        <section className="flex justify-end">
          <Button color="error" onClick={toggle}>
            CANCEL
          </Button>

          <ReactToPrint
            content={() => ref.current}
            onAfterPrint={toggle}
            trigger={() => (
              <Button
                color="primary"
                loading={isLoading ? "true" : undefined}
              >
                PRINT
              </Button>
            )}
          />
        </section>
      </Modal.Footer>
    </Modal>


  )
}